import React from 'react';
import { FormattedMessage } from 'react-intl';

function TableHead(props) {
  return (
    <thead className="thead-light">
      <tr>
        <th
          className="name"
          data-sort="name"
          scope="col"
          onClick={ () => props.applySort('name') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.name" />
        </th>
        <th
          className="notes"
          data-sort="notes"
          scope="col"
          onClick={ () => props.applySort('notes') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.notes" />
        </th>
        <th
          className="start_date"
          data-sort="start_date"
          scope="col"
          onClick={ () => props.applySort('start_date') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.start_date" />
        </th>
        <th
          className="end_date"
          data-sort="end_date"
          scope="col"
          onClick={ () => props.applySort('end_date') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.end_date" />
        </th>

        <th
          scope="row"
          className="w-10"
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.actions" />
        </th>
      </tr>
    </thead>
  )
}

export { TableHead };
